export type LogSource = 'Embeddables' | 'Embeddables Iframe'
export class Log {
  source: LogSource
  constructor(source: LogSource) {
    this.source = source
  }
  warn(message: any, ...optionalParams: any[]) {
    console.warn(
      `%cWarning(${this.source}): \n%c${message}`,
      'color: yellow; font-size: 14px',
      'color: yellow; margin-left: 14px',
      ...optionalParams
    )
  }
  error(message: any, ...optionalParams: any[]) {
    console.error(
      `%cError(${this.source}): \n%c${message}`,
      'color: red; font-size: 14px',
      'color: red; margin-left: 14px',
      ...optionalParams
    )
  }
  info(message: any, ...optionalParams: any[]) {
    console.info(
      `%cInfo(${this.source}): \n%c${message}`,
      'color: cyan; font-size: 14px',
      '',
      ...optionalParams
    )
  }
}
export let log: Log
export const createLog = (source: LogSource) => {
  log = new Log(source)
}
